"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditHandlerMicroservicePatterns = void 0;
var AuditHandlerMicroservicePatterns;
(function (AuditHandlerMicroservicePatterns) {
    AuditHandlerMicroservicePatterns["Audit"] = "Audit";
})(AuditHandlerMicroservicePatterns = exports.AuditHandlerMicroservicePatterns || (exports.AuditHandlerMicroservicePatterns = {}));
